// react component called Services for Terms and Services page

const Services = () => {
  return (
    <div style={{ backgroundColor: "white" }}>
      <h1>Privacy Policy </h1>
      <h5>Introduction</h5>
      <p>
        *1. BioMazze Coordination is committed to protecting the privacy and
        confidentiality of user information. Please refer to our Privacy Policy
        for details on how we collect, use, and safeguard personal data.
      </p>

      <h5>Service Information</h5>
      <p>
        *2. The information provided on the BioMazze Coordination website is for
        general informational purposes only. It does not constitute professional
        advice or a guarantee of specific outcomes. Users are encouraged to
        contact BioMazze Coordination directly for personalized inquiries or
        service requests.
      </p>

      <h5>Intellectual Property</h5>
      <p>
        *3. All content, logos, and images on the BioMazze Coordination website
        are the intellectual property of BioMazze Coordination. Users are
        prohibited from reproducing or using this content without prior
        authorization.
      </p>

      <h5>External Links</h5>
      <p>
        *4. The BioMazze Coordination website may contain links to external
        websites for additional information or resources. BioMazze Coordination
        is not responsible for the content or policies of these external sites.
      </p>

      <h5>Disclaimer of Liability</h5>
      <p>
        *5. BioMazze Coordination strives to provide accurate and uptodate
        information on the website. However, we can not guarantee the
        completeness or accuracy of all content. BioMazze Coordination is not
        liable for any damages or losses resulting from the use of the website
        or the information provided therein.
      </p>

      <h5>Changes to Policy</h5>
      <p>
        *6. BioMazze Coordination reserves the right to update or modify the
        policy and terms and conditions of the website as needed. Users will be
        notified of any changes through the website.
      </p>

      <h5>Contact Information</h5>
      <p>
        *7. For inquiries, feedback, or requests regarding our biologic contract
        services, please contact BioMazze Coordination using the provided
        contact information on the website.
      </p>

      <h5>Conclusion</h5>
      <p>
        By using the BioMazze Coordination website, you acknowledge and agree to
        comply with the policy and terms and conditions outlined above. If you
        do not agree with these terms, please refrain from using the website.
      </p>
      <p>
        Thank you for visiting BioMazze Coordination and considering our
        biologic contract services for your specialty medication authorization
        needs.
      </p>
      <p>Sincerely, BioMazze Coordination</p>
    </div>
  );
};
export default Services;
